// VueJS
import Vue from 'vue'
import App from './App.vue'
import router from './router'

// Styles
import 'bulma'
import '../node_modules/@mdi/font/css/materialdesignicons.min.css'

Vue.config.productionTip = true

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
